import { httpClient } from '@/services/http/httpClient'

type DownloadAttachmentProps = {
  attachmentId: string
}

export const downloadAttachment = async ({
  attachmentId,
}: DownloadAttachmentProps) => {
  const { data } = await httpClient.get(
    `/ideas/funnel/steps/attachment/${attachmentId}/download`,
    {
      responseType: 'blob',
    },
  )

  return data
}
